export default __webpack_public_path__ + "static/media/foglionote.62687fb2.png";